import { SelectEnum } from "@edgetier/select";
import { ComponentProps } from "react";

export enum PhraseTriggerMessageSource {
    Customer = "Customer",
    Agent = "Agent",
    Bot = "Bot",
}

export interface IProps extends Omit<ComponentProps<typeof SelectEnum>, "description" | "items" | "name"> {}
